var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.notifications
    ? _c("div", { staticClass: "col-12 p-0 m-0 h-100" }, [
        _c("h3", [_vm._v("Notifications")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "scroll-panel" },
          [
            _vm._l(_vm.notifications, function(notification) {
              return _c("div", { attrs: { for: notification.id } }, [
                notification.data.message
                  ? _c(
                      "div",
                      {
                        staticClass: "notification",
                        class: !notification.viewed_ts ? "new" : ""
                      },
                      [
                        _c("i", {
                          staticClass: "fas",
                          class: _vm.iconType(notification.data.title)
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "message",
                          domProps: {
                            innerHTML: _vm._s(notification.data.message)
                          }
                        }),
                        _c("span", { staticClass: "timestamp" }, [
                          _vm._v(_vm._s(notification.ts))
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            }),
            _vm._v(" "),
            _vm.notifications.length == 0
              ? _c("div", { staticClass: "mt-4 h-100 scroll-panel" }, [
                  _c(
                    "div",
                    { staticClass: "alert alert-warning text-center" },
                    [_vm._v("No Notifications")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43a3e4e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a3e4e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = null
// module chunks = 